<style scoped>

</style>

<template>
  <mu-card>
    <mu-card-text>
      <h3 class="item-title">
        {{channel.name}}
      </h3>
      <div v-for="child in channel.children">
        <AnalyticsItem 
          :object="child" 
          graphMode
          />
      </div>
    </mu-card-text>
  </mu-card>
</template>

<script>
import AnalyticsItem from '@/components/Analytics/Item/Main.vue'

export default {
  name: "AnalyticsChannel",
  props: {
    channel: {
      type: Object,
      required: true
    }
  },
  components: {
    AnalyticsItem,
  },
  created() {

  },
};
</script>
